module.exports = __webpack_public_path__ + "static/media/SuffixPasswordIcon.52d2a027.svg";